import { Rectangle } from "../../lib/math";
import { MapEntity } from "../../lib/gamemap/MapEntity";
import { TileArea } from "../../lib/runescape/coordinates/TileArea";
import { RenderingUtility } from "../ui/map/RenderingUtility";
import { TileCoordinates, TileRectangle } from "../../lib/runescape/coordinates";
import { FloorLevels } from "../../lib/gamemap/ZoomLevels";
import Properties from "../ui/widgets/Properties";
import { C } from "../../lib/ui/constructors";
import { Clues } from "../model/Clues";
import { GameMap } from "../../lib/gamemap/GameMap";
import { LeafletPolygonConstructors } from "../../lib/gamemap/LeafletPolygonConstructors";
export var ClueEntities;
(function (ClueEntities) {
    var interactionMarker = RenderingUtility.interactionMarker;
    var npc = C.npc;
    var staticentity = C.staticentity;
    var digSpotRect = Clues.digSpotRect;
    var item = C.item;
    var hbox = C.hbox;
    var areaPolygon = LeafletPolygonConstructors.areaPolygon;
    var boxPolygon = LeafletPolygonConstructors.boxPolygon;
    class NpcEntity extends MapEntity {
        constructor(name, range) {
            super();
            this.name = name;
            this.range = range;
            this.floor_sensitivity_layers = FloorLevels.none;
            this.floor_sensitivity_layers = FloorLevels.special(range.origin.level);
        }
        bounds() {
            return TileArea.toRect(this.range);
        }
        async render_implementation(props) {
            const floor_group = this.floor_sensitivity_layers.get(props.floor_group_index);
            if (props.highlight) {
                const range = areaPolygon(this.range)
                    .setStyle({
                    color: floor_group.value.correct_level ? "yellow" : "gray",
                    interactive: false,
                    opacity: 0.5,
                    fillOpacity: 0.1
                }).addTo(this);
            }
            const marker = interactionMarker(TileArea.activate(this.range).center(), "talk", props.highlight ? 1.5 : 1, true, floor_group.value.correct_level ? undefined : "ctr-entity-wrong-level")
                .addTo(this);
            return marker.getElement();
        }
    }
    ClueEntities.NpcEntity = NpcEntity;
    class ObjectEntity extends MapEntity {
        constructor(name, box, cursor) {
            super();
            this.name = name;
            this.box = box;
            this.cursor = cursor;
            this.floor_sensitivity_layers = FloorLevels.none;
            this.floor_sensitivity_layers = FloorLevels.special(box.level);
        }
        bounds() {
            return this.box;
        }
        async render_implementation(props) {
            const floor_group = this.floor_sensitivity_layers.get(props.floor_group_index);
            const range = boxPolygon(this.box)
                .setStyle({
                color: "cyan",
                interactive: this.cursor == null,
                weight: props.highlight ? 4.5 : 3,
                opacity: 1,
                fillOpacity: 0.1,
                pane: GameMap.objectPane
            }).addTo(this);
            if (this.cursor) {
                const marker = interactionMarker(TileRectangle.center(this.box), this.cursor, props.highlight ? 1.5 : 1, true, floor_group.value.correct_level ? undefined : "ctr-entity-wrong-level")
                    .addTo(this);
                return marker.getElement();
            }
            return range.getElement();
        }
    }
    ClueEntities.ObjectEntity = ObjectEntity;
    class TalkSolutionNpcEntity extends NpcEntity {
        constructor(name, spot) {
            super(name, spot.range);
            this.name = name;
            this.spot = spot;
            this
                .setTooltip(() => {
                const layout = new Properties();
                layout.header(hbox("Talk to", C.space(), npc(name), C.space(), "to solve the clue"));
                if (spot.note) {
                    layout.named("Note", spot.note);
                }
                return layout;
            });
        }
    }
    ClueEntities.TalkSolutionNpcEntity = TalkSolutionNpcEntity;
    class SearchSolutionEntity extends ObjectEntity {
        constructor(sol) {
            super(sol.entity, sol.spot, "search");
            this.sol = sol;
            this.setTooltip(() => {
                const layout = new Properties();
                layout.header(hbox("Search", C.space(), staticentity(sol.entity), C.space(), "to solve the clue"));
                if (sol.key) {
                    layout.named("Key", "If you do not have 'way of the footshaped key' unlocked, you will need to get a key.");
                    layout.named("Instructions", sol.key.instructions);
                    layout.named("Solution", sol.key.answer);
                }
                return layout;
            });
        }
    }
    ClueEntities.SearchSolutionEntity = SearchSolutionEntity;
    class DigSolutionEntity extends MapEntity {
        constructor(sol) {
            super();
            this.sol = sol;
            this.floor_sensitivity_layers = FloorLevels.none;
            this.floor_sensitivity_layers = FloorLevels.special(sol.spot.level);
            this.setTooltip(() => {
                const layout = new Properties();
                if (sol.description) {
                    layout.header(`Dig ${sol.description} to solve the clue`);
                }
                else {
                    layout.header(`Dig at ${TileCoordinates.toString(this.sol.spot)} to solve the clue`);
                }
                return layout;
            });
        }
        bounds() {
            return Rectangle.from(this.sol.spot);
        }
        async render_implementation(props) {
            const floor_group = this.floor_sensitivity_layers.get(props.floor_group_index);
            const range = DigSolutionEntity.areaGraphics(this.sol.spot).addTo(this);
            const marker = interactionMarker(this.sol.spot, "shovel", props.highlight ? 1.5 : 1, true, floor_group.value.correct_level ? undefined : "ctr-entity-wrong-level")
                .addTo(this);
            return marker.getElement();
        }
    }
    ClueEntities.DigSolutionEntity = DigSolutionEntity;
    (function (DigSolutionEntity) {
        var tilePolygon = LeafletPolygonConstructors.tilePolygon;
        function areaGraphics(spot, single_tile = false) {
            return (single_tile ? tilePolygon(spot) : boxPolygon(digSpotRect(spot)))
                .setStyle({
                color: "gray",
                interactive: false,
                opacity: 0.5,
                fillOpacity: 0.1
            });
        }
        DigSolutionEntity.areaGraphics = areaGraphics;
    })(DigSolutionEntity = ClueEntities.DigSolutionEntity || (ClueEntities.DigSolutionEntity = {}));
    class EmoteAreaEntity extends MapEntity {
        constructor(clue) {
            super();
            this.clue = clue;
            this.floor_sensitivity_layers = FloorLevels.none;
            this.floor_sensitivity_layers = FloorLevels.special(clue.area.origin.level);
            this.setTooltip(() => {
                const layout = new Properties();
                layout.header("Emote area");
                if (clue.double_agent) {
                    layout.paragraph(`Perform the ${clue.emotes.length > 1 ? "emotes" : "emote"} here. Kill the double agent to summon and talk to Uri.`);
                }
                else {
                    layout.paragraph(`Perform the ${clue.emotes.length > 1 ? "emotes" : "emote"} here to summon and talk to Uri.`);
                }
                {
                    let row = c();
                    for (let i = 0; i < clue.items.length; i++) {
                        const itm = clue.items[i];
                        if (i > 0) {
                            if (i == clue.items.length - 1)
                                row.append(", and ");
                            else
                                row.append(", ");
                        }
                        row.append(item(itm));
                    }
                    layout.named("Items", row);
                }
                {
                    let row = c();
                    for (let i = 0; i < clue.emotes.length; i++) {
                        const emote = clue.emotes[i];
                        if (i > 0) {
                            if (i == clue.emotes.length - 1)
                                row.append(", then ");
                            else
                                row.append(", ");
                        }
                        row.append(emote);
                    }
                    layout.named(clue.emotes.length != 1 ? "Emotes" : "Emote", row);
                }
                if (clue.double_agent) {
                    layout.header("Spawns double agent", "left", 1);
                }
                return layout;
            });
        }
        bounds() {
            return TileArea.toRect(this.clue.area);
        }
        async render_implementation(props) {
            const floor_group = this.floor_sensitivity_layers.get(props.floor_group_index);
            const scale = props.highlight ? 2 : 1;
            const range = areaPolygon(this.clue.area)
                .setStyle({
                color: "#914183",
                weight: scale * 2,
                pane: GameMap.areaPane
                //interactive: false,
            })
                .addTo(this);
            /*const marker = leaflet.marker(LeafletUtils.latLongFromVector2(Rectangle.center(TileArea.toRect(this.clue.area))), {
              icon: leaflet.icon({
                iconUrl: "/assets/icons/emotes.png",
                iconSize: [scale * 24, scale * 30],
                iconAnchor: [scale * 12, scale * 15],
                className: floor_group.value.correct_level ? "" : "ctr-entity-wrong-level"
              })
            }).addTo(this)*/
            return range.getElement();
        }
    }
    ClueEntities.EmoteAreaEntity = EmoteAreaEntity;
    class HideyHoleEntity extends ObjectEntity {
        constructor(clue, with_cursor) {
            super(clue.hidey_hole.name, clue.hidey_hole.location, with_cursor ? "equip" : undefined);
            this.clue = clue;
            this.setTooltip(() => {
                const layout = new Properties();
                layout.header(staticentity(this.clue.hidey_hole.name));
                layout.paragraph("Hidey-holes are used to store the items needed for an emote clue.");
                return layout;
            });
        }
    }
    ClueEntities.HideyHoleEntity = HideyHoleEntity;
})(ClueEntities || (ClueEntities = {}));
